/**
 * Håller reda på ljudkällans id och nästa sekvensnummer per möte, så att en
 * omladdad sida kan fortsätta inspelningen utan att sekvensnummer krockar.
 */
export interface SourceState {
  source_id: string;
  next_sequence: number;
  offset_ms: number;
}

// Prefixet mr. är kvar från Meeting Robot; ett nytt prefix skulle tappa pågående inspelningars sekvensnummer.
const key = (meetingId: string) => `mr.source.${meetingId}`;

function uuid(): string {
  if (crypto.randomUUID) return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

export function loadSourceState(meetingId: string): SourceState {
  try {
    const raw = localStorage.getItem(key(meetingId));
    if (raw) return JSON.parse(raw) as SourceState;
  } catch {
    /* privat läge eller blockerad lagring */
  }
  const fresh = { source_id: uuid(), next_sequence: 0, offset_ms: 0 };
  saveSourceState(meetingId, fresh);
  return fresh;
}

export function saveSourceState(meetingId: string, state: SourceState): void {
  try {
    localStorage.setItem(key(meetingId), JSON.stringify(state));
  } catch {
    /* ignoreras */
  }
}

export function clearSourceState(meetingId: string): void {
  try {
    localStorage.removeItem(key(meetingId));
  } catch {
    /* ignoreras */
  }
}
